var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vk-modal',_vm._g({staticClass:"WARNING-MODAL"},_vm.$listeners),[_c('vk-modal-body',{staticClass:"bg-transparent"},[_c('transition',{attrs:{"name":"WARNING-SLIDE","appear":""}},[_c('vk-modal-content',{staticClass:"WARNING-MODAL-CONTENT p-0"},[_c('vk-modal-close',{staticClass:"WARNING-CLOSE"}),_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }